import styled from "styled-components";
import {LineHeader} from "@FRAMEWORK/ui/desktop/layout";
import {RatingHeader} from "@FRAMEWORK/ui/desktop/filter";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";

const Wrap = styled.div`
	position: relative;
	width: 1200px;
	margin: 0 auto 60px;
	box-sizing: border-box;
`;

const Header = styled.header`
	width: 1200px;
	display: flex;
	padding: 24px 0;
	margin: 0 auto 20px;
	border-bottom: 1px solid var(--emp-color);
	justify-content: space-between;
	align-items: center;

	h2 {
		line-height: 1;
		font-weight: bold;
		color: var(--emp-color);
		font-size: 32px;
	}
`;

const ProductHeader = styled(LineHeader)`
	margin: 20px 0 20px;
	padding: 0 0 20px;
	h3 {
		line-height: 1;
		font-weight: bold;
		color: var(--emp-color);
		font-size: 32px;
	}
`;

const ConfirmButton = styled.a`
	display: flex;
	width: 111px;
	border: 1px solid var(--bl-color);
	border-radius: 30px;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	line-height: 1;
`;

const Logo = styled.a`
	width: 155px;
	height: 42px;
`;

const LocalmainTitle = styled.h3`
	margin-top: 60px;
	line-height: 1;
	font-size: var(--large-size);
	font-weight: bold;
	color: #222;
`;

const LocalList = styled.ul`
	position: relative;
	display: grid;
	grid-template-columns: repeat(5, 240px);
	margin-top: 20px;
	border-top: none;
	border-left: none;
	box-sizing: border-box;

	li {
		box-sizing: border-box;

		a {
			position: relative;
			display: flex;
			height: 50px;
			color: var(--emp-color);
			justify-content: center;
			align-items: center;

			&:hover {
				width: 100%;
				background-color: var(--emp-color);
				color: #fff;
			}
		}
	}

	&::after {
		content: "";
		position: absolute;
		background-image: linear-gradient(to bottom, var(--bl-color) 1px, transparent 1px),
			linear-gradient(to right, var(--bl-color) 1px, transparent 1px);
		top: 0;
		left: 0;
		right: -1px;
		bottom: -1px;
		background-size: 240px 50px;
		z-index: -1;
	}
`;

const ProductList = styled.ul`
	display: grid;
	margin-top: 20px;
	grid-gap: 20px;
	gap: 20px;
	grid-template-columns: repeat(4, 1fr);

	li {
		a {
			display: block;
			box-sizing: border-box;
		}
	}
`;

const Thumbnail = styled.div`
	display: inline-block;
	width: 285px;
	height: 195px;

	img:not(.fallback_thumb) {
		width: 100%;
		height: 100%;
		vertical-align: top;
	}
`;

const InfoBox = styled.div`
	padding: 14px 15px;

	h4 {
		display: -webkit-box;
		overflow: hidden;
		color: var(--emp-color);
		text-overflow: ellipsis;
		white-space: normal;
		word-wrap: break-word;
		word-break: break-all;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		letter-spacing: -0.025em;
	}
`;

const Pirice = styled.span`
	display: block;
	margin-top: 10px;
	font-size: var(--basic-size);
	color: var(--red-color);
	text-align: right;

	em {
		font-size: var(--medium-size);
	}
`;

const CountWrap = styled.div`
	padding-bottom: 20px;
	border-bottom: 1px solid var(--line-color);
`;

const Count = styled.strong`
	margin-left: 6px;
	font-family: "PT-medium";
	font-weight: normal;
	font-size: var(--medium-size);
	color: var(--blue-color);
`;

const LnbNav = styled.div`
	width: 240px;
`;

const CategoryList = styled.ul`
	position: relative;
	display: flex;
	flex-direction: column;
	margin: 20px 0;
	border: 1px solid var(--line-color);
	flex-wrap: wrap;
`;
const CategoryItem = styled.li<{active?: boolean}>`
	display: flex;
	align-items: center;
	flex: 0 0 40px;
	padding: 0 10px;
	cursor: pointer;
	+ li {
		border-top: 1px solid var(--line-color);
	}
	${props =>
		props.active
			? `    background-color: #ffc72c;
    				color: #222;
				`
			: ""}
`;

const Banner = styled.div`
	line-height: 1.6;
	padding: 50px 20px;
	border: 1px solid var(--emp-color);
	font-size: var(--large-size);
	color: var(--emp-color);
	text-align: center;
	> i {
		display: block;
		width: 50px;
		height: 50px;
		margin: 10px auto;
		background: url(${SpriteImage}) no-repeat;
		background-position: -111px -50px;
	}
	> em {
		color: var(--blue-color);
	}
`;

const ProductContent = styled.div`
	position: relative;
	width: 910px;
`;

const RateHeader = styled(RatingHeader)`
	justify-content: flex-end;
	height: 50px;
`;

const Grade = styled.em`
	margin: 0 3px;
	color: var(--emp-color);
`;

const BtnBlock = styled.div`
	display: flex;
	margin-top: 40px;
	justify-content: center;

	@media print {
		display: none;
	}
`;

const ReservationContainer = styled.div`
	width: 910px;
	margin: 0 auto;
	padding-bottom: 100px;
`;

const ReservationPrice = styled.div`
	display: flex;
	padding: 40px 20px;
	margin-top: 40px;
	border: 1px solid var(--line-color);
	justify-content: center;

	ul {
		display: flex;
		justify-content: center;
	}

	li {
		position: relative;
		display: flex;
		padding-right: 40px;
		line-height: 1;
		align-items: center;
		justify-content: space-between;

		&:after {
			content: "";
			position: absolute;
			right: 0;
			top: 2px;
			display: inline-block;
			width: 1px;
			height: 14px;
			margin: 0 20px;
			background-color: var(--line-color);
		}

		&:last-child {
			padding-right: 0;
			&:after {
				display: none;
			}
		}
	}
`;

const Age = styled.span`
	display: flex;
	width: 76px;
	em {
		margin: 0 1px 0 9px;
	}

	span {
		width: 30px;
		text-align: right;
	}
`;

const PriceText = styled.span`
	margin-left: 20px;
	font-size: 16px;
	color: var(--emp-color);

	span {
		margin-left: 3px;
		font-size: var(--default-size);
	}
`;

const TotalPrice = styled.div`
	display: flex;
	margin-top: 20px;
	color: var(--red-color);
	line-height: 1;
	align-items: baseline;
	justify-content: end;
	gap: 3px;

	strong {
		font-size: var(--title-size);
		font-family: "PT-medium";
		font-weight: normal;
	}
`;

const ReservationButton = styled.div`
	width: 200px;
	margin: 40px auto 0;
`;

const ScheduleIconList = styled.div<{totalItems: number}>`
	display: grid;
	padding: 28px 40px;
	margin-top: 20px;
	background-color: var(--disabled-color);
	grid-template-columns: ${props => (props.totalItems <= 8 ? "repeat(4, 1fr)" : "repeat(5, 1fr)")};
	grid-gap: 20px;
	text-align: center;

	li {
		display: flex;
		align-items: center;
		flex-direction: column;
		font-size: var(--default-size);
		color: var(--emp-color);
		line-height: 1.4;
		gap: 11px;
	}
`;

const ScheduleIcon = styled.span<{icon: string}>`
	position: relative;
	display: block;
	width: 75px;
	height: 75px;
	background-color: #fff;
	border-radius: 50%;

	&:after {
		position: absolute;
		top: 50%;
		left: 50%;
		display: block;
		transform: translate(-50%, -50%);
		content: "";
	}
	${props =>
		props.icon === "schedule" &&
		`
        &:after {
            width: 32px;
            height: 32px;
            background: url(${SpriteImage}) no-repeat 0 -204px;
        }
    `}
	${props =>
		props.icon === "air" &&
		`
        &:after {
            width: 42px;
            height: 26px;
            background: url(${SpriteImage}) no-repeat -36px -204px;
        }
    `}
	${props =>
		props.icon === "air-premium" &&
		`
		&:after {
			width: 42px;
			height: 38px;
			background: url(${SpriteImage}) no-repeat -35px -242px;
		}
	`}
    ${props =>
		props.icon === "decide" &&
		`
    &:after {
        width: 30px;
        height: 36px;
        background: url(${SpriteImage}) no-repeat -81px -204px;
    }
    `}
    ${props =>
		props.icon === "guide" &&
		`
    &:after {
        width: 30px;
        height: 34px;
        background: url(${SpriteImage}) no-repeat -114px -204px;
    }
    `}
    ${props =>
		props.icon === "expenses" &&
		`
    &:after {
        width: 36px;
        height: 36px;
        background: url(${SpriteImage}) no-repeat -150px -204px;
    }
    `}
    ${props =>
		props.icon === "seat" &&
		`
    &:after {
        width: 38px;
        height: 34px;
        background: url(${SpriteImage}) no-repeat -193px -204px;
    }
    `}
    ${props =>
		props.icon === "insurance" &&
		`
    &:after {
        width: 30px;
        height: 36px;
        background: url(${SpriteImage}) no-repeat -235px -204px;
    }
    `}
    ${props =>
		props.icon === "charge" &&
		`
    &:after {
        width: 34px;
        height: 34px;
        background: url(${SpriteImage}) no-repeat -270px -204px;
    }
    `}
    ${props =>
		props.icon === "free" &&
		`
    &:after {
        width: 36px;
        height: 36px;
        background: url(${SpriteImage}) no-repeat -307px -204px;
    }
    `}
    ${props =>
		props.icon === "shopping" &&
		`
    &:after {
        width: 32px;
        height: 32px;
        background: url(${SpriteImage}) no-repeat -345px -203px;
    }
    `}
	${props =>
		props.icon === "green" &&
		`
		&:after {
			width: 38px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -82px -242px;
		}
    `}
	${props =>
		props.icon === "caddy" &&
		`
		&:after {
			width: 36px;
			height: 44px;
			background: url(${SpriteImage}) no-repeat -122px -242px;
		}
    `}
	${props =>
		props.icon === "bus" &&
		`
		&:after {
			width: 36px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -160px -242px;
		}
    `}
	${props =>
		props.icon === "ship" &&
		`
		&:after {
			width: 38px;
			height: 38px;
			background: url(${SpriteImage}) no-repeat -200px -242px;
		}
    `}
	${props =>
		props.icon === "train" &&
		`
		&:after {
			width: 32px;
			height: 36px;
			background: url(${SpriteImage}) no-repeat -240px -242px;
		}
    `}
	${props =>
		props.icon === "transport-not" &&
		`
		&:after {
			width: 38px;
			height: 38px;
			background: url(${SpriteImage}) no-repeat -274px -242px;
		}
    `}
`;

const OptionBox = styled.div`
	display: flex;
	height: 80px;
	border: 1px solid #eeecd5;
	background-color: #fbf9e1;
	box-sizing: border-box;
	justify-content: center;
	align-items: center;
	gap: 11px;

	p {
		font-size: var(--medium-size);
		color: var(--emp-color);

		strong {
			font-family: "PT-regular";
		}
	}
`;

const ImageItem = styled.img`
	width: 275px;
	height: 185px;
`;

export {
	Wrap,
	Header,
	Logo,
	ConfirmButton,
	LocalmainTitle,
	LocalList,
	ProductList,
	Thumbnail,
	InfoBox,
	Pirice,
	CountWrap,
	Count,
	ProductHeader,
	LnbNav,
	Banner,
	CategoryList,
	CategoryItem,
	ProductContent,
	RateHeader,
	Grade,
	BtnBlock,
	ReservationContainer,
	ReservationPrice,
	Age,
	PriceText,
	TotalPrice,
	ReservationButton,
	ScheduleIconList,
	ScheduleIcon,
	OptionBox,
	ImageItem,
};
